<template>
  <div class="site site-fit site-full site-editor">
    <div :class="{'esign-right-bar-enabled': rightSidebarOpen}" class="site_wrap">
      <!-- Toolbar -->
      <TopToolbar
        @saveTemplate="saveTemplate"
        @toolbarHeight="coordinateData.topBarHeight = $event"
      />

      <!-- Content -->
      <div class="site_content">
        <div class="content_wrap" style="position: relative">
          <!-- Left sidebar-->
          <LeftSidebar @addField="addField($event)" @clear-all-fields="removeAllFieldsDialog = true"/>

          <!-- Main Content -->
          <div id="esign-editor-main-content" ref="content_main" class="content_main flex overflow-scroll" @mousemove="checkDroppable($event)" @scroll="handleScroll">
            <div id="standard-documents" class="standardDocuments" style="flex-grow: 1;">
              <svg id="signer-document" :height="contentMainHeight" :viewbox="`0 0 ${contentMainWidth} ${contentMainHeight}`" :width="contentMainWidth" focusable="false" @click="svgClicked">
                <g ref="DocumentsView" data-view-id="doc-image-container" data-view-name="DocumentsView" transform="matrix(1,0,0,1, 0, 0)">
                  <g id="DocumentView" :transform="`matrix(1,0,0,1, ${LeftAndRightDocumentMargin}, ${LeftAndRightDocumentMargin})`" data-view-id="c241" data-view-name="DocumentView" @load="onDocViewLoad">
                    <!-- Page Views -->
                    <g v-for="(pdf, key) in localDocumentImages" :id="`pdf-${key}`" :key="`pdf-${key}`" :transform="`matrix(1,0,0,1, 0, ${pdf.position})`" data-view-name="PageView">
                      <rect :height="docImage.height" :width="pageViewRectangle" fill="transparent" stroke="0" stroke-width="1.4" x="-1" y="-1"/>
                      <image :id="`document-image-${key}`" :height="docImage.height" :width="docImage.width" :xlink:href="pdf.path" @load="onImgLoad"/>
                      <text :y="docImage.height + 10" class="font-sans" fill="#666666" font-size="8">
                        {{ documentFileName }}
                      </text>
                      <text :x="docImage.width - 20" :y="docImage.height + 10" class="font-sans" fill="#666666" font-size="8">
                        {{ key + 1 }} of {{ localDocumentImages.length }}
                      </text>
                    </g>

                    <!-- Data Fields -->
                    <g v-for="(data, dataKey) in templateStageData" :id="data.id" :key="`fw-signing-element-${data.id}`" v-tippy :content="tippyContent(data)" :status="data.status" :transform="`matrix(1,0,0,1, ${data.x}, ${data.y})`" class="fw-signing-element" draggable="true" opacity="1" selectable @click="checkCoords" @mousedown="selectElement($event, data)">
                      <!-- Signature -->
                      <svg v-if="data.type === 'signature'" :height="data.h" :width="data.w" fill="none" viewBox="0 0 180 180" xmlns="http://www.w3.org/2000/svg">
                        <path d="M125.303 89.4645C124.908 89.4656 124.517 89.387 124.155 89.2338C123.458 88.9413 122.91 88.3942 122.631 87.7127C122.353 87.0311 122.366 86.2709 122.669 85.599L135.361 57.494L131.175 55.2815C130.838 55.1103 130.54 54.8763 130.298 54.5932C130.057 54.3101 129.876 53.9835 129.766 53.6324C129.656 53.2813 129.62 52.9127 129.66 52.548C129.7 52.1834 129.814 51.8299 129.997 51.5083C130.18 51.1867 130.427 50.9032 130.724 50.6745C131.022 50.4458 131.363 50.2763 131.729 50.176C132.096 50.0756 132.479 50.0464 132.857 50.0899C133.234 50.1335 133.6 50.2491 133.931 50.4298L140.417 53.8497C141.046 54.1807 141.523 54.7264 141.756 55.3795C141.988 56.0325 141.958 56.7457 141.672 57.3786L127.938 87.8051C127.715 88.299 127.346 88.7191 126.878 89.0139C126.41 89.3087 125.863 89.4653 125.303 89.4645V89.4645Z" fill="#FEDD55"/>
                        <path d="M90.2271 121.909L87.5039 137.966L66.5716 152.347L60.8956 156.234L61.5846 149.581L64.1438 124.912L77.2511 114.655L90.2271 121.909Z" fill="#FEDD55"/>
                        <path d="M83.6911 103.853L96.6707 111.11L90.151 121.933L77.1714 114.676L83.6911 103.853Z" fill="#D8D9FB"/>
                        <path d="M100.442 114.894L78.3384 102.55L122.398 39.2536C123.476 37.7048 125.126 36.6092 127.012 36.189C128.898 35.7687 130.879 36.0553 132.554 36.9905C134.229 37.9258 135.472 39.4398 136.03 41.2253C136.589 43.0108 136.422 44.9342 135.563 46.6054L100.442 114.894Z" fill="#F2F2FC"/>
                        <path d="M77.9728 133.367L66.5716 152.347L60.8956 156.234L61.5846 149.581L73.0187 130.585C73.2045 130.265 73.4547 129.983 73.7547 129.757C74.0547 129.531 74.3984 129.365 74.7659 129.268C75.1334 129.171 75.5172 129.146 75.8949 129.194C76.2726 129.241 76.6366 129.361 76.9658 129.546C77.2949 129.731 77.5825 129.977 77.8118 130.27C78.0411 130.563 78.2075 130.897 78.3012 131.253C78.395 131.609 78.4142 131.979 78.3579 132.342C78.3015 132.705 78.1706 133.053 77.9728 133.367V133.367Z" fill="#FD9F29"/>
                        <path d="M139.186 158.531H12.8708C12.1094 158.531 11.3792 158.24 10.8408 157.721C10.3025 157.203 10 156.499 10 155.766C10 155.032 10.3025 154.329 10.8408 153.81C11.3792 153.291 12.1094 153 12.8708 153H139.186C139.948 153 140.678 153.291 141.216 153.81C141.755 154.329 142.057 155.032 142.057 155.766C142.057 156.499 141.755 157.203 141.216 157.721C140.678 158.24 139.948 158.531 139.186 158.531V158.531Z" fill="#454D74"/>
                        <path d="M11.544 64.864C14.072 66.592 16.504 67.456 18.84 67.456C21.208 67.456 23.048 66.912 24.36 65.824C25.704 64.736 26.376 63.232 26.376 61.312C26.376 59.744 25.896 58.512 24.936 57.616C23.912 56.624 22.312 55.632 20.136 54.64C19.496 54.32 19.048 54.096 18.792 53.968C16.616 52.944 14.92 51.76 13.704 50.416C12.52 49.072 11.928 47.168 11.928 44.704C11.928 42.24 12.84 40.224 14.664 38.656C16.52 37.088 18.744 36.304 21.336 36.304C23.928 36.304 26.296 36.768 28.44 37.696L27.72 40.336C25.8 39.696 23.928 39.376 22.104 39.376C20.28 39.376 18.744 39.856 17.496 40.816C16.248 41.744 15.624 42.976 15.624 44.512C15.624 46.048 16.056 47.28 16.92 48.208C17.912 49.232 19.672 50.32 22.2 51.472C24.504 52.56 26.072 53.472 26.904 54.208C28.056 55.264 28.776 56.112 29.064 56.752C29.672 58.288 29.976 59.744 29.976 61.12C29.976 64.032 28.968 66.336 26.952 68.032C24.968 69.728 22.408 70.576 19.272 70.576C16.168 70.576 13.336 69.52 10.776 67.408L11.544 64.864ZM40.4145 70.384C38.9425 70.384 37.9185 70.032 37.3425 69.328C36.7665 68.624 36.4785 67.472 36.4785 65.872V47.44H39.9345V63.904C39.9345 65.6 40.0625 66.704 40.3185 67.216C40.5745 67.696 41.3105 67.936 42.5265 67.936L42.6225 70.048C41.8865 70.272 41.1505 70.384 40.4145 70.384ZM36.1425 39.904C36.1425 38.4 36.8785 37.648 38.3505 37.648C39.6945 37.648 40.3665 38.384 40.3665 39.856C40.3665 41.296 39.6625 42.016 38.2545 42.016C36.8465 42.016 36.1425 41.312 36.1425 39.904ZM62.5748 68.56C62.5748 67.056 62.6868 65.632 62.9108 64.288H62.6228C61.4068 68.48 59.0068 70.576 55.4228 70.576C52.7028 70.576 50.6868 69.6 49.3748 67.648C48.0628 65.664 47.4068 62.928 47.4068 59.44C47.4068 55.952 48.3028 52.992 50.0948 50.56C51.9188 48.096 54.5908 46.864 58.1108 46.864C59.4228 46.864 60.7188 47.008 61.9988 47.296C63.3108 47.552 64.5908 47.952 65.8388 48.496L65.8868 68.56C65.8868 72.624 65.1348 75.792 63.6308 78.064C62.1588 80.368 59.6628 81.52 56.1428 81.52C54.8628 81.52 53.5508 81.28 52.2068 80.8C50.8628 80.352 49.7908 79.712 48.9908 78.88L49.5188 77.008C51.3748 78.224 53.5348 78.832 55.9988 78.832C58.4948 78.832 60.2068 77.952 61.1348 76.192C62.0948 74.464 62.5748 71.92 62.5748 68.56ZM55.7588 67.936C60.3348 67.936 62.6228 62.048 62.6228 50.272C61.5988 49.696 60.0948 49.408 58.1108 49.408C53.3748 49.408 51.0068 52.976 51.0068 60.112C51.0068 62.32 51.3748 64.176 52.1108 65.68C52.8468 67.184 54.0628 67.936 55.7588 67.936ZM77.9468 48.4C77.9468 50.096 77.8188 51.52 77.5628 52.672H77.8508C78.2988 50.88 79.1628 49.472 80.4428 48.448C81.7548 47.392 83.3388 46.864 85.1948 46.864C87.7228 46.864 89.4668 47.504 90.4268 48.784C91.3868 50.032 91.8668 51.92 91.8668 54.448C91.8668 54.544 91.8348 56.176 91.7708 59.344C91.7388 62.512 91.7228 64.528 91.7228 65.392C91.7228 66.256 91.8188 66.896 92.0108 67.312C92.2348 67.728 92.9228 67.936 94.0748 67.936L94.1708 70.096C93.7228 70.288 93.0668 70.384 92.2028 70.384C90.6668 70.384 89.6108 70.032 89.0348 69.328C88.4908 68.624 88.2188 67.504 88.2188 65.968C88.2188 65.904 88.2508 64.176 88.3148 60.784C88.3788 57.392 88.4108 55.632 88.4108 55.504C88.4108 53.648 88.1708 52.208 87.6908 51.184C87.2108 50.128 86.2508 49.6 84.8108 49.6C83.4028 49.6 82.2188 50.048 81.2588 50.944C80.3308 51.84 79.6268 53.008 79.1468 54.448C78.2828 57.232 77.8508 60.192 77.8508 63.328V70H74.5388V47.44L77.9468 47.008V48.4Z" fill="black"/>
                      </svg>

                      <!-- Attachment -->
                      <svg v-if="data.type === 'attachment'" :height="data.h" :width="data.w" viewBox="-40 -110 479 480" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <linearGradient id="a">
                          <stop offset="0" stop-color="#006df0"/>
                          <stop offset="1" stop-color="#00e7f0"/>
                        </linearGradient>
                        <linearGradient id="b" gradientUnits="userSpaceOnUse" x1="176.5" x2="176.5" xlink:href="#a" y1="486.856" y2="-43.912"/>
                        <linearGradient id="c" gradientUnits="userSpaceOnUse" x1="208.5" x2="208.5" xlink:href="#a" y1="486.856" y2="-43.912"/>
                        <linearGradient id="d" gradientUnits="userSpaceOnUse" x1="144.5" x2="144.5" xlink:href="#a" y1="486.856" y2="-43.912"/>
                        <linearGradient id="e" gradientUnits="userSpaceOnUse" x1="296.5" x2="296.5" xlink:href="#a" y1="486.856" y2="-43.912"/>
                        <path d="m352.394531 135.519531c-.042969-.78125-.203125-1.546875-.480469-2.28125-.082031-.273437-.183593-.539062-.300781-.796875-.421875-.902344-1.007812-1.71875-1.730469-2.402344l-88-80c-.675781-.59375-1.445312-1.070312-2.277343-1.40625-.242188-.105468-.488281-.152343-.738281-.234374-.621094-.195313-1.261719-.3125-1.910157-.351563-.152343-.023437-.304687-.039063-.457031-.046875h-112v-8c-.027344-22.082031-17.917969-39.9726562-40-40h-16c-22.082031.0273438-39.972656 17.917969-40 40v8h-8c-22.082031.027344-39.972656 17.917969-40 40v352c.027344 22.082031 17.917969 39.972656 40 40h272c22.082031-.027344 39.972656-17.917969 40-40v-304c0-.167969-.089844-.3125-.105469-.480469zm-87.894531-61.429687 59.304688 53.910156h-51.304688c-4.417969 0-8-3.582031-8-8zm-200-34.089844c0-13.253906 10.746094-24 24-24h16c13.253906 0 24 10.746094 24 24v96c0 13.253906-10.746094 24-24 24h-16c-13.253906 0-24-10.746094-24-24v-40h8v40c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-96c0-8.835938-7.164062-16-16-16h-16c-8.835938 0-16 7.164062-16 16v8h-8zm40 8h-16v-8h16zm208 416h-272c-13.253906 0-24-10.746094-24-24v-352c0-13.253906 10.746094-24 24-24h64v72h-16v-48c0-4.417969-3.582031-8-8-8h-24c-4.417969 0-8 3.582031-8 8v48c.027344 22.082031 17.917969 39.972656 40 40h16c22.082031-.027344 39.972656-17.917969 40-40v-72h104v56c0 13.253906 10.746094 24 24 24h64v296c0 13.253906-10.746094 24-24 24zm0 0" fill="url(#b)"/>
                        <path d="m120.5 224h176c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-176c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0" fill="url(#c)"/>
                        <g fill="url(#b)">
                          <path d="m56.5 272h240c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-240c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"/>
                          <path d="m56.5 320h240c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-240c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"/>
                          <path d="m56.5 368h240c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-240c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"/>
                        </g>
                        <path d="m232.5 400h-176c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h176c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0" fill="url(#d)"/>
                        <path d="m312.5 400c-4.417969 0-8 3.582031-8 8v16c0 4.417969-3.582031 8-8 8h-16c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h16c13.253906 0 24-10.746094 24-24v-16c0-4.417969-3.582031-8-8-8zm0 0" fill="url(#e)"/>
                      </svg>


                      <rect :id="`pageIndex-1-dataIndex-${dataKey}`"
                            :class="elementClassObject(data)"
                            :fill="elementFillColor(data)"
                            :fill-opacity="['signature', 'attachment'].includes(data.type) ? 0.20 : 0.75"
                            :height="data.h"
                            :resizable="data.resizable"
                            :width="data.w"
                            class="field-rectangle"
                            rx="1.4239482200647249"
                            ry="1.4239482200647249"
                            selectable
                            stroke="#5CAEFF"
                            stroke-opacity="1"
                            stroke-width="0.7119741100323624"
                            style="pointer-events: all; cursor: pointer;"
                            type="text"
                            @click="signerElementClicked(data)"/>

                      <!-- Checkbox -->
                      <svg v-if="data.type === 'checkbox'" :height="data.h" :width="data.w" style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path v-if="data.value" d="M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" fill="currentColor"/>
                        <path v-else d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" fill="currentColor"/>
                      </svg>

                      <!-- Other -->
                      <text v-if="!['signature', 'attachment', 'text'].includes(data.type)" id="text-1" :font-size="determineDisplayFontSize(data)" :y="determineYTextOffset(data)" fill="#333" font-family="Lucida Console, Andale Mono, monaco, monospace" opacity="1" style="pointer-events: none;" x="1">
                        <tspan dy="9" letter-spacing=".05" x="1">{{ data.text }}</tspan>
                      </text>

                      <!-- Text -->
                      <text v-if="data.type === 'text'" id="text-2" :font-size="determineDisplayFontSize(data)" :y="determineYTextOffset(data)" fill="#333" font-family="Lucida Console, Andale Mono, monaco, monospace" opacity="1" style="pointer-events: none;" x="1">
                        <tspan v-if="data.text.length === 0" dy="9" letter-spacing=".05" opacity=".5" x="1">
                          {{ data.toolTip ? data.toolTip : data.type }}
                        </tspan>
                        <tspan v-for="(lines, lineIndex) in determineTextLines(data)" :key="lineIndex" :dy="lineIndex === 0 ? 9 : 11" letter-spacing=".05" x="1">
                          {{ lines }}
                        </tspan>
                      </text>
                    </g>
                  </g>

                  <!-- Drag handles -->
                  <FieldDragHandles
                    v-if="currentWorkingDataElement"
                    :element="currentWorkingDataElement"
                    :handles-on="dragHandlesOn"
                    @resize="handleResize"
                  />

                </g>
              </svg>

              <div ref="dataEditor" style=" width: 100px; height: 25px; position: absolute; transform: scale(1); transform-origin: left top;">
                <div class="tab-editor-interface_content">
                  <textarea v-model="editorText" :readonly="currentWorkingDataElement?.readOnly" maxlength="4000" tabindex="-1"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Sidebar -->
          <RightSideColumn
            :document-file-name="documentFileName"
            :document-images="localDocumentImages"
            @scroll-to-page="scrollToPage"
          />

        </div>
      </div>

      <TemplateRightSidebarV2
        @update:esign-field-deleted="dragHandlesOn = false; removeSelectedItems();"

      />
    </div>

    <div v-if="debugDrawerOpen" class="absolute top-o">
      {{ coordinateData }}
    </div>

    <div v-if="debugDrawerOpen" class="absolute top-20 p-1 debug debug-draggable w-52" style="background-color: #0acf97">
      <div class="flex flex-col">
        <small>DEBUG BUTTONS</small>
        <v-btn class="mt-1" size="x-small" @click="adjustDataCoords()">
          adjustDataCoords
        </v-btn>

        <v-btn class="mt-1" color="red" size="x-small" @click="toggleDebugDrawer()">
          TURN OFF DEBUG.
        </v-btn>

        {{ selectedFieldV3Coordinates }}

        {{ docImage }} <br>

        {{ contentLeftSidebarWidth }}<br>

        {{ LeftAndRightDocumentMargin }} <br>
        {{ scrollTop }} <br>

      </div>
    </div>

    <div v-if="debugDrawerOpen" class="border debug debug-draggable relative overflow-hidden" style="height: 600px; width: 300px;max-width: 300px;bottom: 10px; left: 0; opacity: 90%; background-color: rgba(0,0,0,0.90)">
      <div>
        <div class="text-white small fixed debug-draggable__header">The First Staged Data item</div>
        <code>
          <pre v-html="formatJson(firstStagedData)"/>
        </code>
      </div>
    </div>

    <v-dialog v-model="removeAllFieldsDialog" width="400">
      <v-card>
        <v-card-title>Are you sure?</v-card-title>

        <v-card-text>
          You are about to delete all the fields on this document and start over.
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="grey"
            variant="text"
            @click="removeAllFieldsDialog = false"
          >
            Nevermind
          </v-btn>
          <v-btn color="error" @click="removeAllFields()">
            Reset Fields
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script lang="ts" setup>
import {computed, onBeforeUnmount, onMounted, ref, type ShallowRef, useTemplateRef, watch} from 'vue';
import TemplateRightSidebarV2 from '@/views/documentsV2/TemplateRightSidebarV2.vue';
import LeftSidebar from '@/components/dashboard/documents/LeftSidebar.vue';
import TopToolbar from '@/components/dashboard/documents/TopToolbar.vue';
import RightSideColumn from '@/components/dashboard/documents/RightSideColumn.vue';
import FieldDragHandles from '@/components/dashboard/documents/FieldDragHandles.vue';
import {dragElement, round} from '@/helpers';
import type {ESignerFieldData, ESignTool} from '@/types/esign';
import {useCompany} from '@/composables/useCompany';
import {useESign} from '@/composables/useESign';
import {useAppSettings} from '@/composables/useAppSettings';
import {useTemplate} from '@/composables/useTemplate';
import {useRoute} from 'vue-router';
import {push} from 'notivue'
import {d} from '@/utils/consoleHelper.ts';

export interface documentImagesInterface {
  position: number;
  path: string;
}

interface StandardDocCoords {
  top: number;
  left: number;
  right: number;
  bottom: number;
  height: number;
  width: number;
  x: number;
  y: number;
}

interface CoordinateData {
  x: number;
  y: number;
  page: number;
  pageId: string | null;
  pageTop: number;
  clientY: number;
  clientX: number;
  item_x: number;
  item_y: number;
  item_height: number;
  topBarHeight: number;
}

const route = useRoute();
const {company} = useCompany();
const {getTemplate, updateTemplate} = useESign();
const {toggleDebugDrawer, debugDrawerOpen} = useAppSettings();
const {
  documentsLoading,
  selectedFieldV2,
  allTools,
  template,
  selectedFieldV3Coordinates,
  updateSelectedField,
  templateStageData,
  updateStageData,
  templateDocumentImages,
  documentImages,
  setDocumentImages,
  addToStageData,
  makeFieldId,
  removeAllStageData,
  setSingleTemplate,
  setToolsActive,
  currentSigner,
  documentFileName,
} = useTemplate();


const content_main = useTemplateRef('content_main') as ShallowRef<HTMLElement>;
const dataEditor = useTemplateRef('dataEditor') as ShallowRef<HTMLElement>;

const documentUuid = route.params.uuid as string;
const standardDoc = ref<HTMLElement | null>(null);
const standardDocCoords = ref<StandardDocCoords | null>(null);
const pageMarginY = 32;
const contentMainWidth = ref(612);
const contentMainHeight = ref(825);
const contentLeftSidebarWidth = ref(300);
const mainContentStartingXPosition = ref(260);
const scrollTop = ref(0);
const originalContentMainWidth = ref(612);
const originalContentMainHeight = ref(792);
const localDocumentImages = ref<documentImagesInterface[]>([]);
const currentWorkingDataElement = ref<ESignerFieldData | null>(null);
const elementOffsetX = ref(0);
const elementOffsetY = ref(0);
const dragHandlesOn = ref(false);


const coordinateData = ref<CoordinateData>({
  x: 0,
  y: 0,
  page: 1,
  pageId: null,
  pageTop: 0,
  clientY: 0,
  clientX: 0,
  item_x: 0,
  item_y: 0,
  item_height: 0,
  topBarHeight: 42,
})

const removeAllFieldsDialog = ref(false);
const editorText = ref('');
const searchTool = ref('');
const currentWorkingFieldId = ref<string | null>(null);
const currentWorkingTarget = ref('');

const handleScroll = (event: Event) => {
  const target = event.target as HTMLElement;
  scrollTop.value = target.scrollTop;
};


const getCanvasOffset = computed(() => {
  if (!standardDocCoords.value) {
    return {
      top: 0, left: 0, right: 0, bottom: 0, height: 0
    };
  }


  const top = standardDocCoords.value.top - scrollTop.value + 20;
  const left = standardDocCoords.value.left + window.scrollX;
  const right = standardDocCoords.value.right;
  const bottom = standardDocCoords.value.bottom;
  const height = standardDocCoords.value.height;
  const page = 0;
  return {
    page: Number(page),
    top: Number(top.toFixed(3)),
    left: Number(left.toFixed(3)),
    right: Number(right.toFixed(3)),
    bottom: Number(bottom.toFixed(3)),
    height: Number(height.toFixed(3)),
  };
});

const determineRelativeY = (topPosition: number): number => {
  const pos = topPosition - getCanvasOffset.value.top;

  if (pos <= docImage.value.height) return round(pos, 5);
  const totalPages = templateDocumentImages.value.length;

  let relTopPos = 0;
  for (let i = 1; i <= totalPages; i++) {
    const relPosition = (docImage.value.height * i);
    const pageYGap = pageHeightAdjust(i);
    if (pos >= relPosition - docImage.value.height && pos <= relPosition) {
      relTopPos = pos - (docImage.value.height * (i - 1)) - pageYGap;
    }
  }
  return round(relTopPos, 5);
};


const rightSidebarOpen = computed(() => {
  return selectedFieldV2.value?.id;
});

const LeftAndRightDocumentMargin = computed((): number => {
  return (contentMainWidth.value - pageViewRectangle.value) / 2; // usually 20 px
});

const widthChange = computed((): number => {
  return (pageViewRectangle.value - originalContentMainWidth.value) / originalContentMainWidth.value;
});

const documentStartingXPosition = computed((): number => {
  return LeftAndRightDocumentMargin.value + mainContentStartingXPosition.value; // usually 260 px
});

const objectRatioHeightRev = (scaled: number): number => {
  const newHeight = docImage.value.height;
  const savedHeight = originalContentMainHeight.value;
  const tempScale = scaled / newHeight;
  return round(tempScale * savedHeight, 5);
};

const objectRatioWidthRev = (scaled: number): number => {
  const newWidth = docImage.value.width;
  const savedWidth = originalContentMainWidth.value;
  const tempScale = scaled / newWidth;
  return round(tempScale * savedWidth, 5);
};

const pageHeightAdjust = (page: number): number => {
  return ((pageMarginY * (page - 1)) * 100000) / 100000;
};

const handleWindowResize = () => {
  contentMainWidth.value = content_main.value.clientWidth;
  contentMainHeight.value = contentMainWidth.value / docImage.value.ratio * localDocumentImages.value.length;
};


const getSelectedElements = () => {
  return Array.from(document.querySelectorAll('.field-selected'));
};


const removeSelectedElements = () => {
  const selected = getSelectedElements();

  selected.forEach((f) => {
    f.setAttribute('stroke', '#CAEFF');
    f.setAttribute('stroke-width', '1');
    f.classList.remove('field-selected');
  });

  dragHandlesOn.value = false;
};

const handleKeyup = (evt: KeyboardEvent) => {
  evt.preventDefault();
  const target = evt.target as HTMLElement;
  const key = evt.key.toLowerCase();
  const isInputFocused = ['input', 'textarea'].includes(target.localName);

  if (isInputFocused) return;

  switch (key) {
    /** DELETE / BACKSPACE - Delete Selected Fields */
    case 'backspace':
    case 'delete':
      removeSelectedItems()
      break;

    case 'c':
      if (evt.ctrlKey || evt.metaKey) {
        evt.preventDefault();
        copySelectedElement();
      }
      break;

    /** ESCAPE - Deselect Current Field */
    case 'escape':
      removeSelectedElements();
      currentWorkingDataElement.value = null;
      updateSelectedField(null);
      break;
  }

};

const removeSelectedItems = () => {
  const dropItems = getSelectedElements();
  dragHandlesOn.value = false;

  if (dropItems.length > 0) {
    const elementIdsToRemove = dropItems.map((data) => data.parentElement?.id).filter(Boolean);

    dropItems.forEach((data) => data.setAttribute('style', 'display:none;'));

    // Filter out elements and update the Vuex state using the mutation
    templateStageData.value.forEach((data, index) => {
      if (elementIdsToRemove.includes(data.id)) {
        updateStageData({
          data: {
            id: '',
            x: 0,
            y: 0,
            w: 0,
            h: 0,
          } as ESignerFieldData, index
        }); // Set to null or handle deletion in a mutation
      }
    });

    removeSelectedElements();
    currentWorkingDataElement.value = null;
    updateSelectedField(null);

    push.success({
      message: 'Field removed',
    });
  }

  dragHandlesOn.value = false;
};

const moveSelectedElement = (key: string, evt: KeyboardEvent) => {
  evt.preventDefault();
  const selected = getSelectedElements();

  const moveStep = evt.shiftKey ? 10 : 1; // Shift + Arrow Key moves by 10 px, otherwise 1 px


  if (selected.length > 0) {
    const elementId = selected[0].parentElement?.id;
    const dataIndex = templateStageData.value.findIndex((data) => data.id === elementId);

    if (dataIndex !== -1) {
      const data = templateStageData.value[dataIndex];
      let newX = data.x;
      let newY = data.y;

      switch (key) {
        case 'arrowup':
          newY -= moveStep;
          break;
        case 'arrowdown':
          newY += moveStep;
          break;
        case 'arrowleft':
          newX -= moveStep;
          break;
        case 'arrowright':
          newX += moveStep;
          break;
      }

      console.dir(`newX: ${newX}`);
      newX = verifyElementXCoords(newX);
      newY = verifyElementYCoords(newY);
      updateStageData({
        data: {...data, x: newX, y: newY}, index: dataIndex
      });

      currentWorkingDataElement.value = {...data, x: newX, y: newY};
    }
  }
};

const firstStagedData = computed(() => {
  return templateStageData.value[0];
});

const customerDefaultProperties = computed(() => {
  return company.value?.default_properties?.filter((f) => ['customer', 'order'].includes(f.owner_type));
});

const filteredTools = computed((): ESignTool[] => {
  // Filter out disabled tools
  const tools = allTools.value.filter((t: ESignTool) => !t.disabled && t.name.toLowerCase().includes(searchTool.value.toLowerCase()));

  // Map to a specific structure
  const defaultProperties = (customerDefaultProperties.value ?? []).map((dp) => ({
    id: `custom-field-${dp.uuid}`,
    name: dp.name,
    type: 'field',
    category: 'Custom Fields',
    icon: 'mdi-focus-field-horizontal',
    customField: true,
    w: (dp.name.length * 9) + 10,
    h: 20,
  }));

  return [...tools, ...defaultProperties];
});


/**
 * Adjusts the width of the tool based on the current image width
 * NOTE: I set the tool width based on my screen size at the time of development.
 * So, this should be adjusted to the width of the screen when the tool was placed.
 */
const toolWidthAdjusted = (width: number): number => {
  const widthWhenTooling = 928;
  const currentImageWidth = +docImage.value.width;
  const widthDifference = currentImageWidth - widthWhenTooling;
  const widthChangeAdjust = widthDifference === 0
    ? 0
    : widthDifference / widthWhenTooling;

  return round((width + (width * widthChangeAdjust)), 5);
};


/**
 * Adjusts the height of the tool based on the current adjusted width
 * NOTE: I set the tool width based on my screen size at the time of development.
 * So, this should be adjusted to the width of the screen when the tool was placed.
 */
const toolHeightAdjusted = (width: number, height: number): number => {
  return round(toolWidthAdjusted(width) * (height / width), 5);
};

const objectRatioWidth = (width: number): number => objectRatio(width, originalContentMainWidth.value, 'width');

const objectRatioHeight = (height: number): number => objectRatio(height, originalContentMainHeight.value, 'height');

const objectRatio = (value: number, reference: number, label: string): number => {
  const numericValue = Number(value);

  if (isNaN(numericValue)) {
    console.error(`Invalid ${label} value:`, value);
    return 0;
  }

  return Math.abs(parseFloat((numericValue / reference).toFixed(5)));
};

watch(template, (templateNew) => {
  originalContentMainWidth.value = templateNew?.documents?.dimensions?.width ?? 612;
  originalContentMainHeight.value = templateNew?.documents?.dimensions?.height ?? 792;
}, {once: true});


const adjustDocumentContainerHeight = () => {
  const docHeight = pageViewRectangle.value / docImage.value.ratio;
  console.dir(`DOC HEIGHT:: ${docHeight}`);
  console.dir(documentImages.value);

  // Deep clone each image object
  localDocumentImages.value = documentImages.value.map((img: documentImagesInterface) => ({...img}));

  localDocumentImages.value.forEach((p: documentImagesInterface, index: number) => {
    if (index === 0) return;
    p.position = (index * docHeight) + (pageMarginY * index);
  });

  adjustDataCoords();
};


watch(templateDocumentImages, (images) => {
  const docHeight = round(pageViewRectangle.value / docImage.value.ratio, 5);
  console.dir(`Doc Height: ${docHeight}`);
  console.dir(images);

  setDocumentImages(images.map((i, index) => ({
    path: i,
    position: (index * docHeight) + (pageMarginY * index),
  })));

  if (images.length > 0) {
    contentMainWidth.value = content_main.value.clientWidth;
    console.log(`contentMainWidth: ${contentMainWidth.value}`);
    contentMainHeight.value = docImage.value.height / docImage.value.ratio;
    contentMainHeight.value = contentMainWidth.value / docImage.value.ratio * images.length;

    contentLeftSidebarWidth.value = document.getElementById('content_sidebar-left')?.clientWidth ?? 0 as unknown as number;


    adjustDocumentContainerHeight();
  }
});

const scrollToPage = (pageIndex: number) => {
  console.log('scrollToPage!!');
  console.dir(pageIndex);

  const pagePosition = localDocumentImages.value[pageIndex].position;
  content_main.value.scrollTo({
    top: pagePosition,
    left: 0,
    behavior: 'smooth',
  });
};

onMounted(() => {
  getTemplate(documentUuid);

  window.addEventListener('resize', handleWindowResize, false);
  document.addEventListener('keyup', handleKeyup, false);
  document.addEventListener('keydown', handleKeydown, false);


  standardDoc.value = document.getElementById('standard-documents');

  // esign-editor-main-content
  const mainContent = document.getElementById('esign-editor-main-content');

  // how far from the left of the window
  mainContentStartingXPosition.value = mainContent?.getBoundingClientRect().left ?? 0;


  // console.dir(standardDoc.value);
  // console.dir(standardDoc.value.getBoundingClientRect());
  const standardDocCoordsRect = standardDoc.value?.getBoundingClientRect() ?? {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 0,
    width: 0,
    x: 0,
    y: 0,
  };

  standardDocCoords.value = {
    top: standardDocCoordsRect.top,
    left: standardDocCoordsRect.left,
    right: standardDocCoordsRect.right,
    bottom: standardDocCoordsRect.bottom,
    height: standardDocCoordsRect.height,
    width: standardDocCoordsRect.width,
    x: standardDocCoordsRect.x,
    y: standardDocCoordsRect.y,
  };

  const draggableDebug = Array.from(document.getElementsByClassName('debug-draggable')) as HTMLElement[];
  draggableDebug.forEach((el) => {
    dragElement(el);
  });
});


const pageViewRectangle = computed(() => {
  return contentMainWidth.value - 40;
});

const templateDocumentDimensions = computed(() => {
  return template.value?.documents?.dimensions ?? {
    width: 612,
    height: 792,
  };
});

const templateDocumentDimensionRatio = computed(() => {
  const h = templateDocumentDimensions.value.height;
  const w = templateDocumentDimensions.value.width;
  return round(w / h, 5);
});

const docImage = computed(() => {
  const width = pageViewRectangle.value;
  const height = width / templateDocumentDimensionRatio.value;
  const ratio = width / height;
  return {
    width,
    height,
    ratio,
  };
});


const adjustDataCoords = () => {
  templateStageData.value.forEach((data: ESignerFieldData, dataIndex: number) => {
    const adjust = pageHeightAdjust(data.page || 1);

    data.xRatio = objectRatioWidth(data.originalX);
    data.yRatio = objectRatioHeight(data.originalY);

    data.x = (docImage.value.width * data.xRatio) < 0 ? 0 : round(docImage.value.width * data.xRatio, 5);
    data.y = Math.round(((docImage.value.height * data.yRatio) + adjust) * 100000) / 100000;
    data.w = round(docImage.value.width * objectRatioWidth(data.originalWidth), 5);
    data.h = round(docImage.value.height * objectRatioHeight(data.originalHeight), 5);
    data.page = determinePageNumber(data.y);

    updateStageData({
      data,
      index: dataIndex,
    });
  });
};

const verifyElementXCoords = (x: number) => {
  // e.clientX - elementOffsetX.value - documentStartingXPosition.value
  console.log('verifyElementXCoords:: ' + x);
  console.log('elementOffsetX.value:: ' + elementOffsetX.value);

  console.log('documentStartingXPosition.value:: ' + documentStartingXPosition.value);
  const element = currentWorkingDataElement.value;

  if (!element) {
    return x;
  }

  const documentWidth = docImage.value.width;

  // 🛑 Prevent movement outside the left side
  if (x < 0) {
    console.log('%c X AXIS CHECK FAILED - Left Side', 'background: #fd0000;');
    return 0; // Prevent going below the first page
  }

  // 🛑 Prevent movement outside the right side
  if (x + element.w > documentWidth) {
    console.log('%c X AXIS CHECK FAILED - Right Side', 'background: #fd0000;');
    return documentWidth - element.w; // Prevent going below the first page
  }

  // ✅ Allow movement across pages
  console.log('%c X AXIS CHECK PASSED', 'background: #a6e22e;');
  return x;

}

const verifyElementYCoords = (finalY: number) => {
  console.log('verifyElementYCoord:: ' + finalY);

  if (finalY < 0) return 0; // Prevent dragging above the first page

  const element = currentWorkingDataElement.value;

  if (!element) {
    return finalY;
  }

  const documentHeight = docImage.value.height;
  const totalPages = localDocumentImages.value.length;
  const currentPage = determinePageNumber(finalY);

  const pageOffset = (currentPage - 1) * (documentHeight + pageMarginY);
  const pageEndY = pageOffset + documentHeight;
  const elementBottom = finalY + element.h;

  // 🛑 Prevent stopping in the page gap
  if ((finalY + element.h) >= pageEndY && finalY < pageEndY + pageMarginY) {
    console.log('%c Y AXIS CHECK FAILED - In Page Gap', 'background: #fd0000; font-size: 20px;');
    return pageEndY - element.h; // Snap to the start of the next page
  }

  // ✅ Fix last page issue: Adjust the final Y limit
  const lastPageHeight = (documentHeight * totalPages) + ((totalPages - 1) * pageMarginY);

  // 🛑 Prevent movement below the last page
  if (currentPage === totalPages && elementBottom > lastPageHeight) {
    console.log('%c Y AXIS CHECK FAILED - Below Last Page', 'background: #fd0000;');
    return lastPageHeight - element.h; // Prevent going below the last page
  }

  // ✅ Handle transitions smoothly (Optional Optimization)
  if (finalY < pageOffset && elementBottom > pageEndY - element.h) {
    console.log('%c Smooth Transition Between Pages', 'background: #00ff00;');
    return pageOffset; // Snap to top of the page when transitioning
  }

  // ✅ Allow movement across pages
  console.log('%c Y AXIS CHECK PASSED', 'background: #a6e22e;');
  return finalY;
};


const dropListener = (e: MouseEvent) => {
  d.dir('drop');
  e.preventDefault();

  if (!currentWorkingDataElement.value) {
    return;
  }

  // currentWorkingDataElement.value.y = determineRelativeY(currentWorkingDataElement.value.y);
  // currentWorkingDataElement.value.y = verifyElementYCoords(currentWorkingDataElement.value.y);

  d.log('%c dropListener ', 'background: #fd0000;');

  d.log('currentWorkingDataElement.value.y:' + currentWorkingDataElement.value.y);
  d.log('getCanvasOffset.value.top ' + getCanvasOffset.value.top);
  try {
    const theDeterminedY = determineRelativeY(currentWorkingDataElement.value.y + getCanvasOffset.value.top);

    d.log('theDeterminedY: ' + theDeterminedY);
    currentWorkingDataElement.value.relativeY = theDeterminedY;
    currentWorkingDataElement.value.originalX = round(objectRatioWidthRev(selectedFieldV3Coordinates.value.x), 5);
    currentWorkingDataElement.value.originalY = objectRatioHeightRev(selectedFieldV3Coordinates.value.y - pageHeightAdjust(selectedFieldV2.value?.page || 1));
    currentWorkingDataElement.value.originalRelativeY = objectRatioHeightRev(theDeterminedY);
  } catch (error) {
    d.error(error);
  }

  elementOffsetX.value = 0;
  elementOffsetY.value = 0;
};


const adjustOriginalCoords = () => {
  templateStageData.value.forEach((data: ESignerFieldData, dataIndex: number) => {
    const adjust = pageHeightAdjust(data?.page || 1);

    templateStageData.value[dataIndex].originalX = objectRatioWidthRev(templateStageData.value[dataIndex].x);
    templateStageData.value[dataIndex].originalY = objectRatioHeightRev(templateStageData.value[dataIndex].y - adjust);

    templateStageData.value[dataIndex].originalWidth = objectRatioWidthRev(templateStageData.value[dataIndex].w);
    templateStageData.value[dataIndex].originalHeight = objectRatioHeightRev(templateStageData.value[dataIndex].h);

    // updateStageData({
    //   data: {
    //     ...templateStageData.value[dataIndex],
    //     originalX: objectRatioWidthRev(templateStageData.value[dataIndex].x),
    //     originalY: objectRatioHeightRev(templateStageData.value[dataIndex].y - adjust),
    //   },
    //   index: dataIndex,
    // });
  });
};

const saveTemplate = () => {
  console.dir('saveTemplate ***********');
  adjustOriginalCoords();

  if (!template.value) {
    return;
  }

  const actions = JSON.stringify(templateStageData.value);

  updateTemplate({
    actions: btoa(encodeURI(actions)),
    template: template.value,
  });
};


const handleKeydown = (evt: KeyboardEvent) => {
  const key = evt.key.toLowerCase();

  /**
   * If the user is pressing the command and s key, then save the document
   * Note: this needs to be on keydown and not keyup
   */
  if (evt.metaKey && key === 's') {
    console.log('save');
    evt.preventDefault();
    if (documentsLoading.value.saving === false) {
      saveTemplate();
    }
  }
  /**
   * If the user is pressing the command and c key then copy the selected element
   */
  if (evt.metaKey && key === 'c') {
    evt.preventDefault();
    copySelectedElement();
  }

  /** ARROW KEYS - Move Selected Field */
  if (key === 'arrowup' || key === 'arrowdown' || key === 'arrowleft' || key === 'arrowright') {
    moveSelectedElement(key, evt);
  }

}

const determinePageNumber = (topPosition: number): number => {
  const pos = Math.max(0, topPosition);
  const documentImageHeight = docImage.value.height;
  const totalPages = templateDocumentImages.value.length;

  if (pos <= documentImageHeight + pageMarginY) return 1;


  for (let i = 1; i <= totalPages; i++) {
    const pageTop = documentImageHeight * (i - 1);
    const pageBottom = (documentImageHeight * i) + pageMarginY;

    // if pos is between pageTop and pageBottom
    if (pos >= pageTop && pos <= pageBottom) {
      console.dir(`PAGE: ${i}`);
      return i;
    }
  }
  return totalPages;
};

const copySelectedElement = () => {
  const selectedElement = getSelectedElements();

  if (selectedElement.length > 0) {
    const selectedElementData = templateStageData.value.find((stageData: ESignerFieldData) => stageData.id === selectedElement[0]?.parentElement?.id);

    if (selectedElementData) {
      const newElement = JSON.parse(JSON.stringify(selectedElementData));
      newElement.id = `${newElement.type}-${makeFieldId()}`;
      newElement.x = selectedElementData.x + 10;
      newElement.y = selectedElementData.y + 10;
      removeSelectedElements();
      removeSelectedElements();
      templateStageData.value.push(newElement);

      push.success({
        message: 'Copied',
      });
    }
  }
};

const checkCoords = (e: MouseEvent) => {
  dragHandlesOn.value = !!(e.target as HTMLElement).hasAttribute('resizable');
};


const formatJson = (json: any) => {
  let html = '<span class="fw-json-start-bracket">{</span>';
  if (json) {

    for (const key in json) {

      if (json.hasOwnProperty(key)) {
        html += `<div class="fw-json-item"><span class="fw-json-key">${key}</span>: <span class="fw-json-value">${json[key]}</span></div>`;
      }
    }
  }
  html += '<span class="fw-json-end-bracket">}</span>';
  return html;
};


const tippyContent = (data: ESignerFieldData) => {
  if (data?.primary_customer) {
    if (data.type === 'signature') {
      return 'Primary - Signature';
    }
    return `Primary - ${data.text}`;
  }

  if (data?.secondary_customer) {
    if (data.type === 'signature') {
      return 'Secondary - Signature';
    }
    return `Secondary - ${data.text}`;
  }
  return data.text;
};

const elementFillColor = (data: ESignerFieldData) => {
  // return data.type === 'signature' ? '#5be8ff' : '#5be8ff';
  return data.type === 'signature' ? '#9970ad' : '#c0af50';
};

const elementClassObject = (data: ESignerFieldData) => {
  return {
    'fw-signing-element-rect': data.primary_customer ?? true,
    'fw-signing-element-rect-secondary': data.secondary_customer ?? false,
  };
};

const determineYTextOffset = (data: ESignerFieldData) => {
  if (['signature', 'attachment'].includes(data.type)) {
    return data.fontSize - (widthChange.value * 7);
  }
  return (widthChange.value * 12);
};

const determineDisplayFontSize = (data: ESignerFieldData) => {
  return ['signature', 'attachment'].includes(data.type) ? (widthChange.value * data.fontSize) : (widthChange.value * data.fontSize) + 10;
};

const countCheckboxes = () => {
  let count = 1;
  templateStageData.value.forEach((data: ESignerFieldData) => {
    if (data.type === 'checkbox') {
      count++;
    }
  });
  return count;
};

const removeAllFields = () => {
  dragHandlesOn.value = false;
  removeSelectedElements();
  removeAllStageData();
  updateSelectedField(null);
  removeAllFieldsDialog.value = false;

  push.success({
    message: 'Removed all fields - Click Save to save your work',
  });
};

const signerElementClicked = (data: ESignerFieldData) => {
  console.log('signerElementClicked - data:', data);
  currentWorkingDataElement.value = data;
  dragHandlesOn.value = data.resizable;
  updateSelectedField(data);
};

const onDocViewLoad = (e: Event) => {
  console.dir('Document View Loaded');
  console.dir(e);
};

const onImgLoad = (payload: Event) => {

  console.log('onImgLoad');
  console.dir(payload);
};

const removeDraggingEventListeners = (elementId: string) => {
  console.dir('removeDraggingEventListeners');
  const signingElement = document.getElementById(elementId);
  const mainContent = document.querySelector('.content_main');

  if (signingElement) {
    signingElement.removeEventListener('dragstart', dragStartListener);
  }
  if (mainContent) {
    mainContent.removeEventListener('dragover', dragOverListener as EventListener);
  }
};

const dragStartListener = (e: DragEvent) => {
  const signingElement = document.getElementById(currentWorkingFieldId.value ?? '');
  console.dir(currentWorkingFieldId.value);
  console.dir(signingElement);
  console.dir('dragstart');
  e.dataTransfer?.setData('text/plain', 'element1');

  const boundingRect = signingElement?.getBoundingClientRect();

  if (!boundingRect) {
    return;
  }

  elementOffsetX.value = e.clientX - boundingRect.left;
  elementOffsetY.value = e.clientY - boundingRect.top;
};

const dragOverListener = (e: MouseEvent) => {
  console.dir('dragOverListener');

  if (!currentWorkingDataElement.value) {
    return;
  }

  currentWorkingDataElement.value.x = verifyElementXCoords(e.clientX - elementOffsetX.value - documentStartingXPosition.value);
  currentWorkingDataElement.value.y = verifyElementYCoords(e.clientY - elementOffsetY.value - getCanvasOffset.value.top);
  currentWorkingDataElement.value.page = determinePageNumber(currentWorkingDataElement.value.y);

  e.preventDefault(); // Allow a drop
};

const svgClicked = (e: MouseEvent) => {
  console.log('%c svgClicked', 'background: #222; color: #bada55');
  const target = e.target as HTMLElement;

  if (!target.parentElement) {
    return;
  }

  console.log(target.parentElement.id);
  dataEditor.value.style.display = 'none';

  if (currentWorkingTarget.value && currentWorkingTarget.value !== target.id) {
    console.log('%c REMOVED field-selected from field 1', 'background: #222; color: #bada55');
    const theId = `#${currentWorkingTarget.value}`;
    const oldTarget = document.querySelector(theId);
    if (oldTarget) {
      oldTarget.classList.remove('field-selected');
    }
  }
  currentWorkingTarget.value = target.parentElement.id;

  const dropItems = document.querySelectorAll('.fw-signing-element[status=droppable]');

  if (dropItems.length > 0) {
    console.log('%c REMOVED field-selected from field 2', 'background: #222; color: #bada55');
    templateStageData.value.forEach((f: ESignerFieldData) => {
      f.status = 'dropped';
    });

    removeSelectedElements();
    currentWorkingDataElement.value = null;
  }

  if (!target.classList.contains('fw-signing-element-rect') && target.id !== 'fw-signing-element-rect-se') {
    console.log('%c REMOVED field-selected from field 3', 'background: #222; color: #bada55');
    target.classList.remove('field-selected');

    if (currentWorkingFieldId.value) {
      removeDraggingEventListeners(currentWorkingFieldId.value);
    }
  }

  if (!target.hasAttribute('selectable')) {
    console.dir('removeSelectedElements');
    removeSelectedElements();
    currentWorkingDataElement.value = null;
    updateSelectedField(null);
  }

  target.classList.add('working');
  initElementsDrag();
};


const initElementsDrag = () => {
  const mainContent = document.querySelector('.content_main');
  const signingElement = document.getElementById(currentWorkingFieldId.value ?? '') as HTMLElement;

  if (signingElement && mainContent) {
    signingElement.addEventListener('dragstart', dragStartListener);

    mainContent.addEventListener('dragover', dragOverListener as EventListener);

    document.body.addEventListener('drop', dropListener);
  }
};


watch(() => contentMainWidth.value, () => {
  dataEditor.value.style.display = 'none';
  adjustDataCoords();
  adjustDocumentContainerHeight();
});

const selectElement = (e: MouseEvent, data: ESignerFieldData) => {
  const target = e.target as HTMLElement;
  console.log('selectElement - resizable:', data.resizable);
  console.log('selectElement - target resizable:', target.hasAttribute('resizable'));

  removeSelectedElements();
  dragHandlesOn.value = target.hasAttribute('resizable');
  currentWorkingFieldId.value = target.parentElement?.id ?? '';
  svgClicked(e);
  if (target.hasAttribute('selectable')) {
    console.dir('selectElement HERE2');
    target.classList.add('field-selected');
    currentWorkingDataElement.value = data;
    signerElementClicked(data);
  }
};

const determineTextLines = (data: ESignerFieldData) => {
  console.log('%c determineTextLines', 'background: #222; color: #bada55');
  const text = data.text;
  if (!text) return [''];

  const words = text.split(' ');

  if (words.length === 0) return [''];
  if (words.length === 1) return [data.text];

  const el = document.createElement('div');
  document.body.appendChild(el);

  el.style.position = 'absolute';
  el.style.display = 'inline';
  el.style.fontSize = `${determineDisplayFontSize(data)}px`;
  // el.style.padding = '0 16px';
  el.style['white-space'] = 'nowrap';

  const rows: string[] = [];
  let usedIndex = 0;
  // loop through each word and check if clientWidth is surpassing maxWidth
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    el.innerHTML += word;
    if (el.clientWidth > data.originalWidth) {
      rows.push(el.innerHTML);
      usedIndex = i;
      el.innerHTML = '';
    } else {
      el.innerHTML += ' ';
    }
  }

  // handle remaining words
  words.splice(0, usedIndex);
  if (words.length > 0) {
    rows.push(words.join(' '));
  }

  document.body.removeChild(el);

  return rows;
};

const checkDroppable = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  const targetParent = target.parentNode as HTMLElement;

  coordinateData.value = {
    ...coordinateData.value,
    pageId: targetParent.id,
    clientY: e.clientY,
    clientX: e.clientX,
  };

  if (targetParent.id.startsWith('pdf-')) {
    updateCoordinateDataForPage(targetParent, e);
  }

  const dropItems = document.querySelectorAll('.fw-signing-element[status=droppable]');

  if (dropItems.length > 0) {
    if (!currentWorkingDataElement.value) {
      return;
    }

    setToolsActive(false);

    const contentMain = document.querySelector('.content_main') as HTMLElement | null;
    if (!contentMain) {
      return;
    }

    const top = e.pageY + contentMain.scrollTop + 2; // Allows the element to follow the mouse on scroll

    currentWorkingDataElement.value.x = e.pageX - documentStartingXPosition.value;
    currentWorkingDataElement.value.y = top
      - 20 // the height of the top of the first page to the top bar height bottom
      - coordinateData.value.topBarHeight;
    currentWorkingDataElement.value.page = determinePageNumber(currentWorkingDataElement.value.y);
    currentWorkingDataElement.value.relativeY = determineRelativeY(currentWorkingDataElement.value.y);

    const theDeterminedY = determineRelativeY(currentWorkingDataElement.value.y + getCanvasOffset.value.top);
    currentWorkingDataElement.value.originalRelativeY = objectRatioHeightRev(theDeterminedY);
  }
};

// 🔹 Helper function to update coordinate data for the current page
const updateCoordinateDataForPage = (targetParent: HTMLElement, e: MouseEvent) => {
  const pageNumber = +targetParent.id.replace('pdf-', '');
  coordinateData.value.page = pageNumber + 1;

  const rect = targetParent.getBoundingClientRect();
  const contentMainElement = document.querySelector('.content_main') as HTMLElement;
  const offsetParent = contentMainElement.offsetParent as HTMLElement;

  coordinateData.value.pageTop = rect.top - offsetParent.offsetTop;

  coordinateData.value.x = e.clientX - rect.left;
  coordinateData.value.y = round(
    e.clientY - coordinateData.value.topBarHeight - coordinateData.value.pageTop - 2
  );
};

const calculateTextWidth = (text: string, fontSize: number) => {
  const charWidthFactor = 0.8;
  return Math.ceil(text.length * fontSize * charWidthFactor);
};


const addField = (typeId = null) => {
  console.log(`%c [ addField ] `, 'background: #DDD; color: #000; font-size: 20px;');

  currentWorkingDataElement.value = null;

  const selectedTool = filteredTools.value.find((t) => t.id === typeId) as ESignTool;
  if (!selectedTool) return;

  const fieldId = `${selectedTool.type}-${makeFieldId()}`;
  const fontSize = selectedTool.fontSize ?? 12;
  const text = selectedTool.type === 'field' ? selectedTool.name : '';

  // 🔹 Dynamically calculate width and height
  const baseWidth = Math.max(text ? calculateTextWidth(text, fontSize) : selectedTool.w ?? 50, 50);
  const adjustedWidth = toolWidthAdjusted(baseWidth);
  const adjustedHeight = toolHeightAdjusted(baseWidth, selectedTool.h ?? 20);

  console.log(`Text: ${text}, Width: ${adjustedWidth}, Height: ${adjustedHeight}`);

  // 🔹 Determine positioning
  const startingX = 10;
  const startingY = 100 + scrollTop.value;
  const originalDimensions = {
    width: objectRatioWidthRev(adjustedWidth),
    height: objectRatioHeightRev(adjustedHeight),
    x: objectRatioWidthRev(startingX),
    y: objectRatioWidthRev(startingY),
    relativeY: objectRatioWidthRev(startingY),
  };

  // 🔹 Create field data
  const fieldData: ESignerFieldData = {
    id: fieldId,
    page: determinePageNumber(startingY),
    x: startingX,
    y: startingY,
    relativeY: startingY,
    w: adjustedWidth,
    h: adjustedHeight,
    originalWidth: originalDimensions.width,
    originalHeight: originalDimensions.height,
    originalX: originalDimensions.x,
    originalY: originalDimensions.y,
    originalRelativeY: originalDimensions.relativeY,
    xRatio: null,
    text,
    title: selectedTool.name ?? '',
    fontSize,
    resizable: selectedTool.resizable ?? true,
    draggable: true,
    status: 'droppable',
    required: selectedTool.required ?? true,
    readOnly: selectedTool.readOnly ?? false,
    typeId: typeId ?? selectedTool.id,
    type: selectedTool.type,
    customField: selectedTool.customField ?? false,
    version: selectedTool.version ?? 2
  };

  // 🔹 Apply conditional properties
  applyConditionalFieldProperties(fieldData, selectedTool);

  // 🔹 Add field to stage and update state
  addToStageData(fieldData);
  updateSelectedField(fieldData);

  currentWorkingDataElement.value = fieldData;
  currentWorkingFieldId.value = fieldId;

  adjustOriginalCoords();
  adjustDataCoords();
};

const applyConditionalFieldProperties = (fieldData: ESignerFieldData, tool: ESignTool) => {
  if (tool.type === 'checkbox') {
    fieldData.value = false;
    fieldData.fieldName = `Checkbox${countCheckboxes()}`;
  }
  if (tool.customField) {
    fieldData[`${currentSigner.value}_customer`] = true;
  }
  if (tool.primary) fieldData.primary_customer = true;
  if (tool.secondary) fieldData.secondary_customer = true;
};

const handleResize = (e: MouseEvent, direction: string) => {
  if (!currentWorkingDataElement.value) return;

  const startX = e.clientX;
  const startY = e.clientY;
  const startWidth = currentWorkingDataElement.value.w;
  const startHeight = currentWorkingDataElement.value.h;

  const handleMouseMove = (moveEvent: MouseEvent) => {
    if (!currentWorkingDataElement.value) {
      return;
    }

    const deltaX = moveEvent.clientX - startX;
    const deltaY = moveEvent.clientY - startY;

    let newWidth = startWidth;
    let newHeight = startHeight;

    switch (direction) {
      case 'nwse':
        newWidth = Math.max(50, startWidth + deltaX);
        newHeight = Math.max(20, startHeight + deltaY);
        break;
      case 'nesw':
        newWidth = Math.max(50, startWidth - deltaX);
        newHeight = Math.max(20, startHeight + deltaY);
        break;
      case 'ew':
        newWidth = Math.max(50, startWidth + deltaX);
        break;
      case 'ns':
        newHeight = Math.max(20, startHeight + deltaY);
        break;
    }

    currentWorkingDataElement.value.w = newWidth;
    currentWorkingDataElement.value.h = newHeight;

    // Update the stage data
    const index = templateStageData.value.findIndex(data => data.id === currentWorkingDataElement.value?.id);
    if (index !== -1) {
      updateStageData({
        data: currentWorkingDataElement.value,
        index
      });
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
};

onBeforeUnmount(() => {
  console.dir('BEFORE_UNMOUNT');
  window.removeEventListener('resize', handleWindowResize, false);
  document.removeEventListener('keyup', handleKeyup, false);
  document.removeEventListener('keydown', handleKeydown, false);

  removeSelectedElements();
  currentWorkingDataElement.value = null;


  updateSelectedField(null);
  setSingleTemplate(null);
});
</script>

<style>
.fw-json-item {
  color: #f8f8f2;
  margin-left: 16px;
}

.fw-json-key {
  color: #f92672;
}

.fw-json-value {
  color: #a6e22e;
}

.fw-json-start-bracket, .fw-json-end-bracket {
  color: #f92672;
}

.debug-draggable {
  position: absolute;
  z-index: 9;
  background-color: #f1f1f1;
  border: 1px solid #d3d3d3;
}

.debug-draggable__header {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #2196F3;
  color: #fff;
}

.left-sidebar-group.left-sidebar-group-active {
  background-color: #f9f9f9;
}

.fw-signing-element-rect {
  fill: #5be8ff;
  stroke: #5CAEFF;
  stroke-width: 1;
}

.fw-signing-element-rect-secondary {
  fill: #975bff !important;
  stroke: #975bff !important;
  stroke-width: 1;
}

.field-selected {
  fill: red;
  stroke: blue;
  stroke-width: 2;
}

.resizable {
  position: relative;
}

[draggable=true] {
  -webkit-user-drag: element;
}

svg:not(:root) {
  overflow: hidden;
}

.working + text > tspan {
  color: red;
}

.content_sidebar-right {
  border-left: 1px solid #fd0000;
}

.site {
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}

.site-fit .content_wrap {
  height: 100%;
}

.site-fit {
  max-height: 100vh;
}

.site-fit {
  height: 100vh;
}

.site-editor {
  background-color: #e9e9e9;
}

.site-full .content_wrap,
.site-full .footer_wrap,
.site-full .header_wrap,
.site-full .hero_wrap,
.site-full .toolbar_wrap {
  max-width: none;
}

.site_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}

.content_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  flex-grow: 1;
  min-height: 0;
  width: 100%;
}

.content_wrap,
.footer_wrap,
.header_wrap,
.hero_wrap,
.toolbar_wrap {
  margin: 0 auto;
  max-width: 1506px;
}

.content_main {
  min-width: 0;
}

.content_main {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}

.standardDocuments {
  position: relative;
}

.site_footer, .site_header, .site_hero {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

.site-editor .site_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}

.site-fit .site_content {
  flex-basis: 0;
}

.site_content,
.site_content.content,
.site_content > .content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
  min-height: 0;
}

.site, .site_content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
  width: 100%;
}

.site_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-box-orient: horizontal;
  -ms-flex-direction: row;
  flex-direction: row;
  min-height: 0;
}

.l-flex-between {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.l-flex-between > :first-child {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  min-width: 0;
}

.drawer.down > .drawer-wrapper,
.drawer.up > .drawer-wrapper {
  width: 100%;
}


.documentPage .bar-action .btn-action {
  display: block;
  float: right;
  height: 28px;
  margin: 0;
  padding: 0;
  text-align: center;
  width: 28px;
}

.content_sidebar.sidebar-showingDrawer {
  overflow: hidden;
}

.accordion {
  background: 0 0;
  border: 0;
  cursor: pointer;
  display: block;
  font-size: inherit;
  line-height: 20px;
  padding: 6px 48px 6px 24px;
  position: relative;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
}

.documentPage {
  background-color: #fff;
  border: 1px solid #ccc;
  cursor: pointer;
  display: block;
  margin: 0 auto 14px;
  position: relative;
  width: 132px;
}

.documentPage img {
  display: block;
  height: auto;
  width: 100%;
}

.documentPage .bar-action {
  background-color: #e9e9e9;
  bottom: 0;
  height: 28px;
  position: absolute;
  width: 100%;
}

.content_sidebar-right {
  position: relative;
}


.content_sidebar {
  max-width: 375px;
  min-width: 220px;
  overflow: hidden;
  width: 220px;
}

.site-editor .sidebar_header {
  border-bottom: 1px solid #d9d9d9;
  padding: 13px 24px;
}

.form_item-iconLeft, .form_item-iconRight {
  position: relative;
}

.site-editor .toolbar_left,
.site-editor .toolbar_main,
.site-editor .toolbar_right {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  min-height: inherit;
}

.site-fit .content_sidebar {
  overflow-y: auto;
}

.site-editor .toolbar_left {
  max-width: 375px;
  min-width: 220px;
  padding-left: 12px;
  width: 240px;
}

.site-editor .toolbar_right {
  max-width: 375px;
  min-width: 220px;
  width: 220px;
}

.site-editor .toolbar_right {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding-right: 24px;
}

.form_item-iconLeft, .form_item-iconRight {
  position: relative;
}

.form_item-iconRight .input-text {
  padding-right: 29px;
}

.sidebarTabs {
  background: #e9e9e9;
  list-style: none;
  margin: 0;
  padding: 0 !important;
}


.menu-fields {
  margin-left: -15px;
  margin-right: -15px;
}

.tab-editor-interface_content {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.tab-editor-interface_content textarea {
  -webkit-writing-mode: horizontal-tb !important;
  writing-mode: horizontal-tb !important;
  text-rendering: auto;
  color: black;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  background-color: rgb(255, 255, 255);
  -webkit-rtl-ordering: logical;
  flex-direction: column;
  cursor: text;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  margin: 0;
  font: 400 13px Arial;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(118, 118, 118);
  border-image: initial;
  padding: 2px;
}

.tab-editor-interface_content textarea:focus {
  outline: none;
}

.tab-editor-interface_content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}

text {
  display: block;
  white-space: nowrap;
}
</style>
